var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"h-footer"},[_vm._v(" Copyright© h365 all rights reserved 2021. ")])}
var staticRenderFns = []

export { render, staticRenderFns }